module.exports = __webpack_public_path__ + "media/images/loader-time-744de57085c1b1e743161460679d50f2.gif";